// extracted by mini-css-extract-plugin
export default {"buttonTextOuter":"ButtonText_buttonTextOuter__4413v","name":"ButtonText_name__A-zTq"};